// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2fuJR","actionsCol":"EnrolledClinics_actionsCol__2JBjE"};